import React from 'react';
import PropTypes from 'prop-types';
import useAuthority from 'utils/hooks/useAuthority';

/**
 * AuthorityCheck component is a custom component responsible for checking user authority.
 * It is used to check if the user has the required authority to access a component.
 */
const AuthorityCheck = (props) => {
    const { userAuthority = [], authority = [], children } = props;

    const roleMatched = useAuthority(userAuthority, authority);

    return roleMatched ? children : <></>;
};

AuthorityCheck.propTypes = {
    userAuthority: PropTypes.array,
    authority: PropTypes.array,
};

export default AuthorityCheck;
